// extracted by mini-css-extract-plugin
module.exports = {"dialogue":"dialogue_dialogue__Q80wd","resetCodeText":"dialogue_resetCodeText__ha0wO","paymentContainer":"dialogue_paymentContainer__sTpUk"};